import { Component, inject } from '@angular/core';
import { AuthService } from './_services/auth.service';

import { RouterLink } from '@angular/router';


@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    imports: [RouterLink]
})
export class VerifyEmailComponent {
  authService = inject(AuthService);
}